export const SOCIALS = {
  instagram: {
    handle: "@rae.enterprise.llc",
    url: "https://www.instagram.com/rae.enterprise.llc/",
  },
  facebook: {
    handle: "Rae Enterprise LLC",
    url: "https://www.facebook.com/profile.php?id=100077703125213",
  },
  linkedin: {
    handle: "rae-enterprise-llc",
    url: "https://www.linkedin.com/company/rae-enterprise-llc",
  },
};
